import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import CustomButton from '../../../component/CustomButton';

const AddTileModal = (props) => {
    const {
        onHide, onSave, tiles, tileOrder,
    } = props;
    const { t } = useTranslation('translation', { keyPrefix: 'dashboardPage.addTileModal' });
    const [stagedOrder, setStagedOrder] = useState(tileOrder);

    const handleToggleTile = (key) => setStagedOrder((prev) => (prev.includes(key)
        ? prev.filter((tileKey) => tileKey !== key)
        : [...prev, key]));

    const handleSave = () => onSave(stagedOrder);

    return (
        <Modal show onHide={onHide} className="modal-lg-size add-tile-modal">
            <Modal.Header closeButton>
                <Modal.Title>{t('title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="add-tile-modal__description">{t('description')}</p>
                <ul className="add-tile-modal__list">
                    {tiles.map(({ key, label }) => {
                        const isSelected = stagedOrder.includes(key);
                        return (
                            <li key={key} className="add-tile-modal__row">
                                <span className="add-tile-modal__row-label">{label}</span>
                                <CustomButton
                                    variant={isSelected ? 'secondary-outline' : 'primary-outline'}
                                    onClick={() => handleToggleTile(key)}
                                >
                                    {isSelected ? t('btnRemove') : t('btnAdd')}
                                </CustomButton>
                            </li>
                        );
                    })}
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <CustomButton variant="primary" onClick={handleSave}>{t('btnSave')}</CustomButton>
            </Modal.Footer>
        </Modal>
    );
};

AddTileModal.propTypes = {
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    tiles: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    tileOrder: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AddTileModal;
